<template>
    <!-- 엄마아기병원 -->
    <template v-if="['mom01','mom001','mom02','mom03', 'mom04'].includes(deptCd)">
        <div v-for="key in doctorList" :key="key" class="info">
            <h3 class="bullet01" v-if="key.deptNm && key.doctorList?.length">{{key.deptNm}}</h3>
            <ul class="doctor-list" >
                <li class="doctor-list__item" v-for="doctor in key.doctorList" :key="doctor">
                    <div class="doctor-list--img" v-if="doctor.img === 'lha'">
                        <!--   김현우 이현아 이미지             -->
                        <img src="/resource/img/lee-hyun-ah.png" alt="" style="transform: scale(1.4); transform-origin: center center;">
                    </div>
                    <div class="doctor-list--img" v-else-if="doctor.attachBag">
                        <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" onerror="this.style.display='none'">
                    </div>
                    <div class="doctor-list--img" v-else>
                        <!--   김현우 이미지 없는곳             -->
                    </div>
                    <div class="doctor-list--con">
                        <div class="doctor-list--text">
                            <!-- active : add on -->
                            <kr_FavoHeart :info="favoInfo(doctor)" @getList="this.$emit('getList')" v-if="checkStaticData(doctor)"/>
    
                            <template v-if="doctor.img ==='lha'">
                                <div class="doctor-list--name-wrap">
                                    <h3 class="doctor-list--name">이현아 간호팀장</h3>
                                    <span class="title03 font-sub">에드먼즈간호교육센터장</span>
                                </div>
                                <p class="doctor-list--department">간호부 특수간호팀</p>
                            </template>
    
                            <template v-else>
                                <div class="doctor-list--name-wrap">
                                    <h3 class="doctor-list--name">{{doctor.drName ? doctor.drName : doctor.name}} 교수</h3>
                                    <!-- 엄마아기 -->
                                    <span class="title03 font-sub" v-if="['mom01','mom001','mom02','mom03'].includes(doctor.mainDeptCd)">{{doctor.position}}</span>
                                </div>
                                <!-- 엄마아기 -->
                                <p class="doctor-list--department" v-if="['mom01','mom001','mom02','mom03'].includes(doctor.mainDeptCd)">
                                <span class="font-main">{{doctor.belong.split(',')[0]}}</span> {{doctor.doctorDeptList ? doctor.doctorDeptList.filter(item => item.deptType != '0').map(item => item.deptNm).join(',') : doctor.belong}}
                                </p>
                                <p class="doctor-list--department" v-else>{{doctor.belong}}</p>
    
                                <h4 class="doctor-list--clinic" v-if="doctor.detailField">전문진료분야</h4>
                                <p class="doctor-list--desc">{{doctor.detailField}}</p>
                            </template>
                        </div>
                        <div class="doctor-list--button" v-if="checkStaticData(doctor)">
                            <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'N')">진료예약</a>
                            <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'Q')">빠른예약</a>
                            <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank">의료진소개</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </template>
    <template v-else-if="['MYEL','CART','LYMP','LEUK','PED','TRAN','HEMO','BHL','BMF','MPN','ANEM','THRM'].includes(deptCd)">
        <div v-for="key in doctorList" :key="key" class="info">
            <h3 class="bullet01" v-if="key.deptNm && key.doctorList?.length">{{key.deptNm}}</h3>
            <ul class="doctor-list" >
                <li class="doctor-list__item" v-for="doctor in key.doctorList" :key="doctor">
                    <div class="doctor-list--img">
                        <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs" onerror="this.style.display='none'">
                        <img :src="getImg(doctor)" alt="이미지" v-else-if="doctor.imageSrc" @error="this.style.display='none'">
                    </div>
                    <div class="doctor-list--con">
                        <div class="doctor-list--text">
                            <!-- active : add on -->
                            <kr_FavoHeart :info="favoInfo(doctor)" @getList="this.$emit('getList')" v-if="checkStaticData(doctor)"/>

                            <div class="doctor-list--name-wrap">
                                <h3 class="doctor-list--name">{{doctor.drName ? doctor.drName : doctor.name}} {{checkStaticData(doctor) ? '교수' : ''}}</h3>
                            </div>
                            <p class="doctor-list--department">{{doctor.belong}}</p>

                            <h4 class="doctor-list--clinic" v-if="doctor.detailField">전문진료분야</h4>
                            <p class="doctor-list--desc">{{doctor.detailField}}</p>
                        </div>
                        <div class="doctor-list--button" v-if="checkStaticData(doctor)">
                            <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'N')" v-if="checkRsv(doctor)">진료예약</a>
                            <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'Q')" v-if="checkRsv(doctor)">빠른예약</a>
                            <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank">의료진소개</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </template>
    <!-- 그 외 -->
    <template v-else-if="this.$store.getters.getHost == 'H0009' && this.$route.query.deptCd == undefined && groupedDoctorList?.length">
        <div v-for="key in groupedDoctorList" :key="key.mainDeptNm" class="info">
            <h3 class="bullet01" v-if="key.mainDeptNm && key.doctorList?.length">{{key.mainDeptNm =="혈액내과" ? "혈액내과/소아청소년과":key.mainDeptNm}}</h3>
            <ul class="doctor-list">
                <li class="doctor-list__item" v-for="doctor in key.doctorList" :key="doctor">
                    <div class="doctor-list--img">
                        <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs" onerror="this.style.display='none'">
                        <img :src="getImg(doctor)" alt="이미지" v-else-if="doctor.imageSrc" @error="this.style.display='none'">
                    </div>
                    <div class="doctor-list--con">
                        <div class="doctor-list--text">
                            <!-- active : add on -->
                            <kr_FavoHeart :info="favoInfo(doctor)" @getList="this.$emit('getList')" v-if="checkStaticData(doctor)"/>

                            <div class="doctor-list--name-wrap">
                                <h3 class="doctor-list--name">{{doctor.drName ? doctor.drName : doctor.name}} {{checkStaticData(doctor) ? '교수' : ''}}</h3>
                            </div>
                            <p class="doctor-list--department">
                                {{getDeptDisplay(doctor)}}
                            </p>
                            <h4 class="doctor-list--clinic" v-if="doctor.detailField">전문진료분야</h4>
                            <p class="doctor-list--desc">{{doctor.detailField}}</p>
                        </div>
                        <div class="doctor-list--button" v-if="checkStaticData(doctor)">
                            <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'N')" v-if="checkRsv(doctor)">진료예약</a>
                            <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'Q')" v-if="checkRsv(doctor)">빠른예약</a>
                            <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank">의료진소개</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </template>
    <ul class="doctor-list" v-else>
        <li class="doctor-list__item" v-for="doctor in doctorList" :key="doctor">
            <div class="doctor-list--img">
                <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs" onerror="this.style.display='none'">
                <img :src="getImg(doctor)" alt="이미지" v-else-if="doctor.imageSrc" @error="this.style.display='none'">
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <!-- active : add on -->
                    <kr_FavoHeart :info="favoInfo(doctor)" @getList="this.$emit('getList')" v-if="checkStaticData(doctor)"/>

                    <div class="doctor-list--name-wrap">
                        <h3 class="doctor-list--name">{{doctor.drName ? doctor.drName : doctor.name}} {{checkStaticData(doctor) ? '교수' : ''}}</h3>
                    </div>
                    <p class="doctor-list--department">{{doctor.belong}}</p>

                    <h4 class="doctor-list--clinic" v-if="doctor.detailField">전문진료분야</h4>
                    <p class="doctor-list--desc">{{doctor.detailField}}</p>
                </div>
                <div class="doctor-list--button" v-if="checkStaticData(doctor)">
                    <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'N')" v-if="checkRsv(doctor)">진료예약</a>
                    <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'Q')" v-if="checkRsv(doctor)">빠른예약</a>
                    <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank">의료진소개</a>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
export default{
    props: {
        doctorList: '',
        groupedDoctorList: {
            type: Array,
            default: () => []
        },
        isAllDept: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            deptCd: this.$route.query.deptCd || ''
        }
    },
    methods: {
        checkRsv(doctor){
            if(this.$store.getters.getHost != 'H0009'){
                return true
            }
            if(doctor?.appointYn != 'Y'){
                return false
            }
            if(doctor?.doctorDeptList?.length > 0){
                for(let i of doctor.doctorDeptList){
                    if(i.deptType == '0'){
                        return i.rsvYn == 'Y'
                    }
                }
            }else if(doctor?.doctorDept?.rsvYn == 'Y'){
                return true
            }
            return false
        },
        getImg(doctor){
            if(!doctor.imageSrc){
                return false
            }
            try{
                return require(`@/assets/resource/img/${doctor.imageSrc}`)
            }catch(err){
                return require(`@/assets/resource/img/doctor_bg.png`)
            }
        },
        favoInfo(info){
            const obj = {}
            obj.favoYn = info.favoYn == 'Y' ? 'Y' : 'N'
            obj.no = info.drSid
            obj.type = 'DOCTOR'
            obj.doctorDetail = false
            return obj
        },
        normalReservation(doctor){
            this.getDoctorReserveDate(doctor, 'N')
        },
        quickReservation(doctor){
            this.getDoctorReserveDate(doctor, 'Q')
        },
        checkStaticData(doctor){
            return doctor.img !== 'lha' && doctor.img !== 'none' && doctor.imageSrc == null
        },
        getNormalizedMainDeptNm(doctor) {
            if (String(doctor?.drSid || '') === '1001705') {
                return '혈액내과 ,  소아청소년과'
            }
            return doctor?.mainDeptNm || ''
        },
        getDeptDisplay(doctor) {
            return this.getNormalizedMainDeptNm(doctor)
        },
        getDoctorReserveDate(doctor, type){
            this.axios.get(this.api.doctor.getDate, {
                params: {
                    drSid: doctor.drSid
                }
            })
            .then(res => {
                const data = res.data
                if(data.code == 'OK'){
                    if(type == 'N'){
                        this.$store.state.reserveStore.normalReserve = doctor
                    }
                    if(type == 'Q'){
                        this.$store.state.reserveStore.quickReserve = doctor
                    }
                    this.$store.state.patInfoStore = {}
                    this.$router.push('/kr/reserve/reservation')
                }else{
                    alert(data.result)
                    if(data.code == 'not login'){
                        this.$router.push('/kr/login')
                    }
                }
            })
        }
    },
}
</script>